import { FC, HTMLAttributes } from 'react';

type iOSProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const iOS: FC<iOSProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.89844"
        y="2.01514"
        width="10.1695"
        height="11.2995"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.93746 4.45755C9.63428 4.45755 9.27654 4.52825 8.86423 4.66964C8.45192 4.8111 8.15482 4.88187 7.97291 4.88194C7.83142 4.88194 7.54543 4.81926 7.11494 4.69391C6.68445 4.56856 6.31762 4.50588 6.01443 4.50588C5.30301 4.50588 4.71385 4.80507 4.24697 5.40344C3.78009 6.00152 3.54665 6.77557 3.54665 7.72558C3.54849 8.25142 3.62609 8.77424 3.77706 9.27794C3.9432 9.82833 4.17315 10.3574 4.46222 10.8543C4.76943 11.392 5.07866 11.7952 5.38993 12.064C5.70116 12.3328 6.01443 12.4672 6.32975 12.4672C6.53993 12.4672 6.81379 12.3974 7.15133 12.2579C7.48887 12.1185 7.78496 12.0487 8.03962 12.0487C8.29427 12.0487 8.60653 12.1155 8.9764 12.2489C9.34625 12.3824 9.63629 12.4491 9.8465 12.4491C10.1133 12.4491 10.3801 12.348 10.6468 12.1458C10.9136 11.9437 11.1804 11.6385 11.4472 11.2302C11.6161 10.9751 11.769 10.7099 11.905 10.4359C12.0273 10.1898 12.1297 9.93432 12.2112 9.67187C11.8433 9.56285 11.5159 9.30214 11.2289 8.88974C10.9437 8.48337 10.7932 7.99779 10.7984 7.50136C10.7996 7.1646 10.8752 6.83226 11.0197 6.5281C11.1673 6.21075 11.4654 5.86213 11.9141 5.48224C11.6271 5.12649 11.3239 4.86673 11.0046 4.70297C10.6738 4.53661 10.3077 4.45241 9.93746 4.45755ZM9.83438 2.1171C9.11082 2.28262 8.59239 2.58983 8.27911 3.03872C7.96584 3.48738 7.80517 4.01889 7.79711 4.63323C8.11239 4.61712 8.36504 4.56659 8.55505 4.48162C8.76386 4.38345 8.95292 4.24783 9.11285 4.0815C9.36184 3.83935 9.55797 3.54825 9.68888 3.22654C9.81015 2.91933 9.87079 2.63641 9.87078 2.37776C9.87078 2.33737 9.86874 2.29698 9.86471 2.25637C9.85919 2.20907 9.84902 2.16242 9.83438 2.1171ZM8 0C12.4183 0 16 3.58161 16 8.00011C16 12.4184 12.4183 16 8 16C3.58172 16 0 12.4184 0 8.00011C0 3.58162 3.58172 0 8 0Z"
        fill="#030712"
      />
    </svg>
  );
};

export default iOS;
